// Declare Analytics Custom Link Var
const AnalyticsCustomLink = function (obj, linkParam) {

  if (window.location.host === "sp-preview.nsse.np.norton.com" || window.location.host === "support.norton.com") {
    var nortonAnalyticsEnv = "symanteccom,symantecconsumersupport";
  } else {
    var nortonAnalyticsEnv = "veritasdev";
  }

  var s=s_gi(nortonAnalyticsEnv);
  s.tl(obj,'o',linkParam);
}

export {AnalyticsCustomLink};